/**
 * `580` — *{When, dateTriggerConfig} {date, columnId} arrives*, with its offset.
 *
 * Time-based: it subscribes to no domain event. The scheduler materialises one
 * `automation_schedules` row per item from `dateTriggerDueAt()` and re-materialises whenever the
 * date cell changes; the trigger then matches the synthetic `automation.schedule.due` event by
 * automation id. `allowedTypes` is `["date","timerange"]` in monday's own catalogue
 * (`sandbox-experiments.md` E5), so a timeline column is a legal target — it fires on the `to`
 * date (**ASSUMED**, open question 19).
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { AUTOMATION_SCHEDULE_DUE } from '../events.js';
import { columnRefSchema, dateTriggerConfigSchema } from '../values.js';
export const dateArrivesParams = z.object({
    columnId: columnRefSchema,
    dateTriggerConfig: dateTriggerConfigSchema,
});
export const dateArrivesTrigger = defineTrigger({
    id: '580',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: '{When, dateTriggerConfig} {date, columnId} arrives',
    paramsSchema: dateArrivesParams,
    requiredColumnTypes: ['date', 'timeline'],
    subscribes: [AUTOMATION_SCHEDULE_DUE],
    timeBased: true,
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    matches: () => true,
    outputs(event) {
        return { itemId: event.itemId, boardId: event.boardId, dueAt: event.payload.dueAt };
    },
});
//# sourceMappingURL=580.js.map